import { Container, Box } from "@sembark-travel/ui-base"
import {
	useGetBackUrlFromLocation,
	Breadcrumbs,
} from "@sembark-travel/ui-router"
import { Helmet } from "react-helmet-async"
import { generatePath, useNavigate } from "../../../router-utils"
import { NewTouristProfile } from "../../../TouristProfiles"

export default function NewTouristProfilePage() {
	const navigate = useNavigate()
	const backFromUrl = useGetBackUrlFromLocation()
	return (
		<>
			<Helmet>
				<title>New Tourist Profile</title>
			</Helmet>
			<Breadcrumbs
				title="New Tourist Profile"
				items={[
					[generatePath("/org/tourists/profiles"), "Tourist Profiles"],
					["", "New"],
				]}
			/>
			<Box paddingX={{ md: "4" }} paddingY={{ md: "8" }}>
				<Box maxWidth="6xl" marginX="auto">
					<Box borderWidth={{ md: "1" }} rounded="md" bgColor="default">
						<Container paddingY="6">
							<NewTouristProfile
								onSuccess={(touristProfile) =>
									navigate("/tourist-profiles/:touristProfileId", {
										params: {
											touristProfileId: touristProfile.id.toString(),
										},
										replace: true,
									})
								}
								onCancel={() =>
									backFromUrl
										? navigate(backFromUrl as "/org/tourists/profiles", {
												replace: true,
											})
										: navigate("/org/tourists/profiles", { replace: true })
								}
							/>
						</Container>
					</Box>
				</Box>
			</Box>
		</>
	)
}
